module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid15_800x744.bdda352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid15_800x744.jpg
// module id = dNk8
// module chunks = 0